module.exports = __webpack_public_path__ + "static/media/sytem-zetonowy-level3-B.bf120252.jpg";